import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { headerAccessLog } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { sendData } from "../../../services/sendData";
import { useEffect } from "react";

export default function LogAccessBox() {
  const { type, searchValues, setSearchValues, section } =
    useStructureContext();
  const { customUpdate, setWindowValues, setMsg, closeMsg, logoutAction } =
    useMainContext();

  useEffect(() => {
    if ("accessLog" in customUpdate.current) {
      const accessLogResults = searchValues;
      accessLogResults[section.id].results[
        customUpdate.current.accessLog
      ].ACTIP0 = customUpdate.current.info;
      setSearchValues({ ...accessLogResults });
      customUpdate.current = {};
    }
  }, [customUpdate.current]);

  const callAccessLogInfo = async (data: stdObject, index: number) => {
    setMsg("loading");
    const payloadStationeryInfo: stdObject = {
      id: data.IDIP0,
      user: data.USUIP0,
    };
    console.log("payloadStationeryInfo", payloadStationeryInfo);

    const responseStationeryInfo: stdObject = await sendData({
      endPoint: "callAccessLogInfo",
      payload: payloadStationeryInfo,
      logoutAction,
    });
    console.log("responseStationeryInfo", responseStationeryInfo);

    const { status, success, info } = responseStationeryInfo;
    if (success && status) {
      setMsg("accessLogModal");
      setWindowValues({ ...info[0], index });
    } else {
      closeMsg();
    }
  };

  return "FECLOG" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerAccessLog}
        data={searchValues[section.id].results}
        onDoubleClick={(e, index) => {
          callAccessLogInfo(e, index);
        }}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
